import { SortParams } from 'components/Table';
import {
  DataSource,
  
  FilterInput,
  SortOrder,
  useDataSourceConfigurationListQuery,
  
} from '@kinetic-ui/data-layer';
import { useCallback, useMemo, useRef, useState } from 'react';
import { getColumnSortParams, useGetNodes } from 'kineticUtils/data';
import { useInfiniteLoaderQuery, usePagination,useDataSourceSelectionList } from 'kineticUtils/hooks';

export const useDataSourceOptions = (formId: string): DataSource[] => {
  const { data } = useDataSourceSelectionList(formId);
  const nodes = useGetNodes(data?.dataSources);
  return nodes as DataSource[];
};

export const useDataSourcesList = () => {
  const scrollReference = useRef<HTMLDivElement>(null);
  const onPreviousRef = useRef<() => void>();
  const onNextRef = useRef<() => void>();

  const onSearchChange = (searchText: string) => setSearchText(searchText);

  const [filters, setFilters] = useState<FilterInput[]>([]);
  const [searchText, setSearchText] = useState<string>();
  const [sort, setSort] = useState<SortParams>({
    order: SortOrder.Descending,
    field: 'value',
  });

  const onSortChange = useCallback((newSort) => {
    if (Object.keys(newSort).length !== 0) {
      const field = Object.keys(newSort)[0];
      const order = newSort[field];
      setSort({ field, order });
    }
  }, []);

  const { limit } = usePagination({
    onPrevious: onPreviousRef.current,
    scrollRef: scrollReference,
    onNext: onNextRef.current,
  });

  const { throttledRefetch, data, error, loading, InViewComponent, infiniteFooter } =
    useInfiniteLoaderQuery(
      useDataSourceConfigurationListQuery,
      'dataSourceConfigs',
      'dataSourceConfigList',
      {
        sortOrder: sort.order,
        sortField: sort.field,
        after: null,
        searchText,
        filters,
        limit,
      }
    );

  const rowData = useGetNodes(data?.dataSourceConfigs);

  return useMemo(
    () => ({
      throttledRefetch,
      scrollReference,
      onSearchChange,
      onSortChange,
      sort: getColumnSortParams(sort, {}),
      setFilters,
      rowData,
      error,
      loading,
      InViewComponent,
      infiniteFooter,
    }),
    [throttledRefetch, onSortChange, sort, rowData, error, loading, InViewComponent, infiniteFooter]
  );
};
